import $ from 'jquery';

export function initMailchimpSubscriptionForm() {

    $(".mailchimp-subscription-form #zmp_email").on("focus", function () {
        var $this = $(this);

        $this.parents(".mailchimp-subscription-form").addClass("active");
    });

}
